import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { CommitteeMemberDto } from '../shared/dto/committee-member.dto';
import { CommitteeMemberService } from '../shared/committee-member.service';
import { NotificationService } from 'src/app/shared';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'wl-committee-member-edit-dialog',
  templateUrl: './committee-member-edit-dialog.component.html',
  styleUrls: ['./committee-member-edit-dialog.component.less'],
    standalone: false
})
export class CommitteeMemberEditDialogComponent implements OnInit {
  @Input() committeeId: number;
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    this.showChange.emit(this._show);
  }
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @Output() saved: EventEmitter<CommitteeMemberDto> = new EventEmitter();

  committeeMember: CommitteeMemberDto;
  loadingMember: boolean;
  isSaving: boolean;

  get showCrud() {
    return this.committeeMember?.CommitteeMemberID || this.committeeMember?.ProfileID || this.loadingMember;
  }

  private _show: boolean;

  constructor(private _committeeMemberService: CommitteeMemberService, private _notificationService: NotificationService) {}

  ngOnInit(): void {}

  open(committeeMemberId?: number) {
    this.show = true;
    this.committeeMember = {
      CommitteeID: this.committeeId,
      Active: true,
    } as CommitteeMemberDto;
    if (committeeMemberId) {
      this.loadingMember = true;
      this._committeeMemberService
        .get(committeeMemberId, true)
        .then(
          (committeeMember) => {
            this.committeeMember = committeeMember;
          },
          (error) => {
            this._notificationService.httpError(error);
          }
        )
        .finally(() => (this.loadingMember = false));
    }
  }

  initWithProfile(profileId: number) {
    this.committeeMember = {
      CommitteeID: this.committeeId,
      ProfileID: profileId,
      Active: true,
    } as CommitteeMemberDto;
  }

  cancel() {
    this.committeeMember = {
      CommitteeID: this.committeeId,
      Active: true,
    } as CommitteeMemberDto;
    this.show = false;
  }

  save() {
    this.isSaving = true;
    let crudPromise;
    if (this.committeeMember.CommitteeMemberID) {
      if (this.committeeMember.RepresentingOrganizations) {
        let defaultOrg = this.committeeMember.RepresentingOrganizations.find((org) => org.IsPrimaryOrg);

        if (this.committeeMember.OrgProfileID === defaultOrg?.OrgProfileID) {
          this.committeeMember.OrgProfileID = 0;
        }
      }
      crudPromise = this._committeeMemberService.update(this.committeeMember);
    } else {
      crudPromise = this._committeeMemberService.create(this.committeeMember);
    }
    crudPromise
      .then(
        () => {
          this._notificationService.translateSuccess('tasks.edit.saved-successfully');
          this.saved.emit(this.committeeMember);
          this.show = false;
        },
        (error) => {
          this._notificationService.httpError(error);
        }
      )
      .finally(() => {
        this.isSaving = false;
      });
  }

  saveAndAddAnother() {
    this.isSaving = true;
    this._committeeMemberService
      .create(this.committeeMember)
      .then(
        () => {
          this.committeeMember = {
            CommitteeID: this.committeeId,
            Active: true,
          } as CommitteeMemberDto;
        },
        (err) => {
          this._notificationService.httpError(err);
        }
      )
      .finally(() => (this.isSaving = false));
  }
}
